export const sortSourcesWebToTop = (sources) => {
    return sources.sort((a, b) => {
        if (a === 'web' && b !== 'web') {
            return -1;
        }
        if (a !== 'web' && b === 'web') {
            return 1;
        }
        return 0;
    });
};
//# sourceMappingURL=sortSourcesWebToTop.js.map